import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import ReporteFacturacionClientesList from './components/ReporteFacturacionClientesList';
import ReporteFacturacionClienteSearch from './components/ReporteFacturacionClienteSearch';
import ReporteFacturacionClienteDownload from './components/ReporteFacturacionClienteDownload';

const ReporteFacturacionClientes = (props) => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    window.setAppTitle('Facturación');
  }, []);

  const handleOnRowClick = (data) => {
    const fecha = moment(date).format('YYYY-MM-DD');

    props.history.replace({
      pathname: `/admin/reportes/facturacion/${data.cliente_id}/detalle`,
      search: `?fecha=${fecha}`,
      state: {
        data: { ...data },
      },
    });
  };

  const handleOnDateChange = (value) => {
    setDate(value);
  };

  return (
    <div>
      <Row>
        <Col
          sm="auto"
          md="9"
          className="mb-2"
        >
          <ReporteFacturacionClienteSearch onDateChange={handleOnDateChange} />
        </Col>

        {Guardian.allows('reporte.facturacion.descargar') && (
          <Col className="text-right">
            <ReporteFacturacionClienteDownload />
          </Col>
        )}
      </Row>

      <ReporteFacturacionClientesList onRowClick={handleOnRowClick} />
    </div>
  );
};

export default ReporteFacturacionClientes;
